import React, { useEffect, useState, useRef } from "react";
import Styles from "../../styles/admin/dashborad.module.scss";
import Navbar from "../../components/Navbar";
import { getScheduleGym } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import pauseIcon from "../../assets/dashboard/Menu/pause.png";
import playIcon from "../../assets/dashboard/Menu/play.png";
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import { ApiEndpoints, LocalStorageKeys } from "../../core";
import { io } from "socket.io-client";
import { adminRoutes } from "../../routers/AdminRouters";
import { motion, AnimatePresence } from "framer-motion";
import {
  updateIsPlayingState,
  updateProgressState,
  updateRemainingDurationState,
} from "../../redux";
import { FaSearch } from "react-icons/fa";
import InfiniteScroll from "react-infinite-scroll-component";

function secondsToHhmmss(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}
const capitalizeEachWord = (string) => {
  if (!string) return ""; // Handle empty or undefined strings
  return string
    .split(" ") // Split into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
    .join(" "); // Join back into a string
};
const LIMIT = 6;

const Dashboard = () => {
  const { gymSchedule } = useSelector((state) => state.schedule);
  const progressData = useSelector((state) => state.schedule.progress);
  const isPlayingData = useSelector((state) => state.schedule.isPlaying);
  const remainingDurationData = useSelector(
    (state) => state.schedule.remainingDuration
  );
  const [currentDate, setCurrentDate] = useState(new Date());
  const [expandedSession, setExpandedSession] = useState(null);
  const progressIntervals = useRef({});
  const [socket, setSocket] = useState(null);
  const dispatch = useDispatch();
  const [hasStarted, setHasStarted] = useState({});
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("oldest");
  const [displayedGymsSchedule, setDisplayedGymsSchedules] = useState([]);
  useEffect(() => {
    const gymToken = localStorage.getItem(LocalStorageKeys.gymToken);
    if (gymToken) {
      const socketInit = io(ApiEndpoints.serverURL, {
        reconnectionDelayMax: 10000,
        auth: {
          token: `Bearer ${gymToken}`,
        },
      });
      setSocket(socketInit);
    } else {
      console.error("Token not found in local storage");
    }
  }, []);
  useEffect(() => {
    fetchGymScheduled();
  }, []);
  const fetchGymScheduled = async (
    pageNum = page,
    query = "",
    sort = sortOrder
  ) => {
    if (loading) return;

    try {
      setLoading(true);
      console.log("Fetching sessions for page:", pageNum);

      const newSessionsSchedules = await getScheduleGym(
        false,
        pageNum,
        LIMIT,
        query,
        sort
      );

      if (
        newSessionsSchedules &&
        Array.isArray(newSessionsSchedules) &&
        newSessionsSchedules.length > 0
      ) {
        if (pageNum === 1) {
          setDisplayedGymsSchedules(newSessionsSchedules);
        } else {
          setDisplayedGymsSchedules((prev) => [
            ...prev,
            ...newSessionsSchedules,
          ]);
        }

        setPage(pageNum + 1);
        console.log("Fetched new sessions:", newSessionsSchedules.length);
      } else {
        console.log("No more sessions to fetch");
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (e, sort = sortOrder) => {
    const query = e.target.value;
    setSearchQuery(query);

    try {
      setDisplayedGymsSchedules([]);
      setPage(1);

      if (query.trim() === "") {
        setHasMore(true);

        await fetchGymScheduled(1, "", sort);
      } else {
        const newSessions = await getScheduleGym(false, 1, -1, query, sort);
        if (Array.isArray(newSessions)) {
          setDisplayedGymsSchedules(newSessions);
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };
  const handleToggle = (index, event) => {
    if (event.target.closest("button")) return;
    setExpandedSession(expandedSession === index ? null : index);
  };

  const handlePlay = (sessionId, duration) => {
    if (isPlayingData[sessionId]) return;

    socket.emit("preview_control_status", {
      sessionId,
      status: "play",
    });
    // socket.emit("preview_progress_status", {
    //   sessionId,
    //   status: "play",
    // });
    dispatch(updateIsPlayingState({ sessionId, isPlaying: true }));

    const startTime = Date.now();
    const alreadyElapsed = progressData[sessionId]
      ? (progressData[sessionId] / 100) * duration
      : 0;
    const lastRemainingTime = remainingDurationData[sessionId] || duration;
    const adjustedStartTime = startTime - (duration - lastRemainingTime) * 1000;

    let lastEmittedProgress = 0;

    progressIntervals.current[sessionId] = setInterval(() => {
      const elapsed = (Date.now() - adjustedStartTime) / 1000;
      let progressValue = Math.min((elapsed / duration) * 100, 100);
      progressValue = parseFloat(progressValue.toFixed(2));

      if (progressValue >= 100) {
        clearInterval(progressIntervals.current[sessionId]);
        dispatch(updateIsPlayingState({ sessionId, isPlaying: false }));
        window.location.reload();
        return;
      }

      dispatch(
        updateRemainingDurationState({
          sessionId,
          remainingDuration: Math.max(duration - elapsed, 0),
        })
      );
      dispatch(updateProgressState({ sessionId, progress: progressValue }));
    }, 1000);
  };

  const handlePause = (sessionId) => {
    dispatch(updateIsPlayingState({ sessionId, isPlaying: false }));

    if (progressIntervals.current[sessionId]) {
      clearInterval(progressIntervals.current[sessionId]);
    }

    socket.emit("preview_control_status", {
      sessionId,
      status: "pause",
    });

    console.log("preview_control_status");
  };

  const prevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
    );
  };

  const nextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
    );
  };

  const getDaysInMonth = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const lastDate = new Date(year, month + 1, 0).getDate();
    const lastDay = new Date(year, month, lastDate).getDay();
    const nextMonthDays = lastDay < 6 ? 6 - lastDay : 0;
    let days = [];
    for (let i = firstDay - 1; i >= 0; i--) {
      days.push({
        day: new Date(year, month, -i).getDate(),
        currentMonth: false,
      });
    }
    for (let i = 1; i <= lastDate; i++) {
      days.push({
        day: i,
        currentMonth: true,
      });
    }
    for (let i = 1; i <= nextMonthDays; i++) {
      days.push({
        day: i,
        currentMonth: false,
      });
    }
    return days;
  };

  const handleStart = (sessionId) => {
    if (socket) {
      socket.emit("preview_control_status", {
        sessionId,
        status: "start",
      });
      console.log("preview_control_status");
      if (!hasStarted[sessionId]) {
        window.open(adminRoutes.idleScreen, "_blank");
      }
      setHasStarted((prev) => ({ ...prev, [sessionId]: true }));
    } else {
      console.error("Socket not initialized yet.");
    }
  };

  useEffect(() => {
    if (!socket) return;

    socket.on("preview_control_status", (data) => {
      const { sessionId, status } = data;
      console.log(
        "Preview Control Status:",
        status,
        sessionId,
        isPlayingData[sessionId]
      );

      if (status === "play" && !isPlayingData[sessionId]) {
        const scheduleItem = gymSchedule.find((s) => s._id === sessionId);
        const duration = scheduleItem ? scheduleItem.session.duration : 0;
        handlePlay(sessionId, duration);
        dispatch(updateIsPlayingState({ sessionId, isPlaying: true }));
      } else if (status === "pause" && isPlayingData[sessionId]) {
        dispatch(updateIsPlayingState({ sessionId, isPlaying: false }));
        handlePause(sessionId);
      }
    });

    return () => {
      socket.off("preview_control_status");
    };
  }, [
    socket,
    gymSchedule,
    dispatch,
    progressData,
    remainingDurationData,
    isPlayingData,
  ]);

  return (
    <>
      <Navbar />
      <div className={Styles.session_list_container}>
        <div className={Styles.sessions_list}>
          <div className={Styles.dashboard_session_list_child_table_head}>
            <h1>Session List</h1>

            <div className={Styles.rightControls}>
              <select
                className={Styles.sortselect}
                value={sortOrder}
                onChange={(e) => {
                  const selected = e.target.value;
                  setSortOrder(selected);
                  setDisplayedGymsSchedules([]);
                  setPage(1);
                  setHasMore(true);

                  if (searchQuery.trim()) {
                    handleSearch({ target: { value: searchQuery } }, selected);
                  } else {
                    fetchGymScheduled(1, searchQuery, selected);
                  }
                }}
              >
                <option value="oldest">Oldest Sessions</option>
                <option value="latest">Latest Sessions</option>
                <option value="asc">A - Z (Sort in ascending order)</option>
                <option value="desc">Z - A (Sort in descending order)</option>
              </select>

              <div
                className={`${Styles.searchContainerchildtwo} ${
                  searchQuery ? Styles.active : ""
                }`}
              >
                <FaSearch className={Styles.searchIcon} />
                <input
                  type="text"
                  className={Styles.searchInput}
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>
            </div>
          </div>
          <div id="scrollableSessionList" className={Styles.scrollable_content}>
            {!displayedGymsSchedule || displayedGymsSchedule.length === 0 ? (
              <div className={Styles.no_sessions_container}>
                <p
                  style={{
                    textAlign: "center",
                    padding: "10px",
                    color: "white",
                    fontSize: "16px",
                  }}
                >
                  No sessions available
                </p>
              </div>
            ) : (
              <InfiniteScroll
                dataLength={displayedGymsSchedule.length}
                next={fetchGymScheduled}
                hasMore={hasMore}
                loader={
                  <div className={Styles.loader_container}>
                    <p>Loading more sessions...</p>
                  </div>
                }
                endMessage={
                  <div className={Styles.end_message}>
                    <p style={{ textAlign: "center", padding: "10px" }}>
                      No more sessions available
                    </p>{" "}
                  </div>
                }
                scrollableTarget="scrollableSessionList"
              >
                {displayedGymsSchedule.map((schedule, index) => {
                  const sessionId = schedule._id;
                  const duration = schedule.session.duration;
                  const progressValue = progressData[sessionId] || 0;
                  const sessionIsPlaying = isPlayingData[sessionId];
                  const sessionRemaining = remainingDurationData[sessionId];

                  return (
                    <div key={index} className={Styles.session_wrapper}>
                      <div
                        className={Styles.session_card}
                        onClick={(event) => handleToggle(index, event)}
                      >
                        {expandedSession === index &&
                        schedule.session.formats.length > 0 ? (
                          <div className={Styles.session_top_section}>
                            <div className={Styles.progress_bar_container}>
                              <div
                                className={Styles.progress_bar}
                                style={{ width: `${progressValue}%` }}
                              ></div>
                            </div>
                          </div>
                        ) : (
                          expandedSession === index && (
                            <div className={Styles.no_session_message}>
                              No formats available
                            </div>
                          )
                        )}
                        <div className={Styles.session_content}>
                          <div className={Styles.session_date}>
                            <p className={Styles.session_number}>
                              {new Date(schedule.date).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                }
                              )}
                            </p>
                            <p className={Styles.session_day}>
                              {new Date(schedule.date).toLocaleDateString(
                                "en-GB",
                                {
                                  weekday: "long",
                                }
                              )}
                            </p>
                          </div>

                          <div className={Styles.session_separator}></div>

                          <div className={Styles.session_info}>
                            <span className={Styles.session_type}>
                              <strong>
                                {schedule?.session.name
                                  ? capitalizeEachWord(schedule?.session.name)
                                  : "N/A"}
                              </strong>
                            </span>
                          </div>

                          <div className={Styles.session_footer}>
                            <span className={Styles.session_formats}>
                              Formats:{" "}
                              <strong className={Styles.orange_text}>
                                {schedule.session.formats.length} <span>|</span>
                              </strong>
                            </span>
                            <span className={Styles.session_duration}>
                              &nbsp;Duration:{" "}
                              <strong className={Styles.orange_text}>
                                {secondsToHhmmss(
                                  isNaN(sessionRemaining) ||
                                    sessionRemaining === undefined
                                    ? Math.floor(duration || 0)
                                    : Math.floor(sessionRemaining)
                                )}
                              </strong>
                            </span>
                            {expandedSession === index &&
                              schedule.session.formats.length > 0 &&
                              new Date(schedule.date).toDateString() ===
                                new Date().toDateString() && (
                                <div className={Styles.control_buttons}>
                                  {!hasStarted[sessionId] ? (
                                    <button
                                      className={Styles.play_button}
                                      onClick={() => handleStart(sessionId)}
                                    >
                                      Start
                                    </button>
                                  ) : !sessionIsPlaying ? (
                                    <button
                                      className={Styles.play_button}
                                      onClick={() =>
                                        handlePlay(sessionId, duration)
                                      }
                                    >
                                      <img
                                        src={playIcon}
                                        alt="Play Icon"
                                        className={Styles.icon}
                                      />
                                      Play
                                    </button>
                                  ) : (
                                    <button
                                      className={Styles.pause_button}
                                      onClick={() => handlePause(sessionId)}
                                    >
                                      <img
                                        src={pauseIcon}
                                        alt="Pause Icon"
                                        className={Styles.icon}
                                      />
                                      &nbsp; Pause
                                    </button>
                                  )}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                      <AnimatePresence>
                        {expandedSession === index &&
                          schedule.session.formats.length > 0 && (
                            <motion.div
                              className={Styles.session_details}
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: "auto" }}
                              exit={{ opacity: 0, height: 0 }}
                              transition={{ duration: 0.3 }}
                            >
                              <div className={Styles.session_details}>
                                <table className={Styles.session_table}>
                                  <thead className={Styles.table_head}>
                                    <tr>
                                      <th>Format Name</th>
                                      <th>Type</th>
                                      <th>No. Exercise</th>
                                      <th>Duration</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Warm Up</td>
                                      <td>_ _</td>
                                      <td>_ _</td>
                                      <td>
                                        {secondsToHhmmss(
                                          schedule.session.warmupTime
                                        )}
                                      </td>
                                    </tr>
                                    {schedule.session.formats.map(
                                      (format, i, arr) => (
                                        <React.Fragment key={i}>
                                          <tr>
                                            <td>
                                              {format.format.name
                                                .charAt(0)
                                                .toUpperCase() +
                                                format.format.name
                                                  .slice(1)
                                                  .toLowerCase()}
                                            </td>
                                            <td>{format.subFormat}</td>
                                            <td>{format.exercises.length}</td>
                                            <td>
                                              {secondsToHhmmss(
                                                Math.floor(
                                                  format.duration -
                                                    format.restTime
                                                )
                                              )}
                                            </td>
                                          </tr>

                                          {i !== arr.length - 1 && (
                                            <tr>
                                              <td>Rest</td>
                                              <td>_ _</td>
                                              <td>_ _</td>
                                              <td>
                                                {secondsToHhmmss(
                                                  format.restTime
                                                )}
                                              </td>
                                            </tr>
                                          )}
                                        </React.Fragment>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </motion.div>
                          )}
                      </AnimatePresence>
                    </div>
                  );
                })}
              </InfiniteScroll>
            )}
          </div>
        </div>

        <div className={Styles.calendar_container}>
          <div className={Styles.calendar_container_sub}>
            <div className={Styles.calendar_header}>
              <button onClick={prevMonth}>
                <MdArrowBackIos />
              </button>
              <h3>
                {currentDate.toLocaleString("default", {
                  month: "long",
                  year: "numeric",
                })}
              </h3>
              <button onClick={nextMonth}>
                <MdArrowForwardIos />
              </button>
            </div>
            <div className={Styles.calendar_day_labels}>
              {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map(
                (day, index) => (
                  <div key={index} className={Styles.day_label}>
                    {day}
                  </div>
                )
              )}
            </div>
            <div className={Styles.calendar_grid}>
              {getDaysInMonth().map((dayObj, index) => {
                const currentDateStr = new Date(
                  currentDate.getFullYear(),
                  currentDate.getMonth() + (dayObj.currentMonth ? 0 : 1),
                  dayObj.day
                ).toLocaleDateString("en-CA");

                const todayStr = new Date().toLocaleDateString("en-CA");

                const isScheduled = gymSchedule?.some((schedule) => {
                  const scheduleDate = new Date(
                    schedule.date
                  ).toLocaleDateString("en-CA");
                  return scheduleDate === currentDateStr;
                });

                const isPastDay = currentDateStr < todayStr;

                const cellClass = !dayObj.currentMonth
                  ? Styles.next_month_day
                  : isPastDay
                  ? Styles.past_day
                  : currentDateStr === todayStr
                  ? Styles.today_day
                  : isScheduled
                  ? Styles.scheduled_day
                  : Styles.future_day;

                return (
                  <div
                    key={index}
                    className={`${Styles.calendar_cell} ${cellClass}`}
                  >
                    <span className={Styles.day_number}>{dayObj.day}</span>
                  </div>
                );
              })}
            </div>

            <div className={Styles.calender_notify_boxs}>
              <div className={Styles.calender_box_child_one}>
                <button disabled></button>
                <span>Current</span>
              </div>
              <div className={Styles.calender_box_child_two}>
                <button disabled></button> <span>Scheduled</span>
              </div>
              <div className={Styles.calender_box_child_three}>
                <button disabled></button> <span>Completed</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
